import React from 'react';
import { getContrastTextColor } from '../utils/colorUtils';

/**
 * ActivityBlock - Renders a single colored block representing an activity.
 *
 * @param {Object} props
 * @param {string} props.activityCode - The activity code to display
 * @param {string} props.activityName - The full activity name (tooltip)
 * @param {string} props.color - The background color for the block
 * @param {number} props.index - Index in the sequence (for key/debugging)
 */
const ActivityBlock = ({ activityCode, activityName, color, index }) => {
  const textColor = getContrastTextColor(color);

  return (
    <div
      title={activityName}
      className="flex-shrink-0 px-2 py-1.5 rounded text-xs font-medium cursor-default transition-transform hover:scale-105"
      style={{
        backgroundColor: color,
        color: textColor,
        minWidth: '60px',
        maxWidth: '120px',
        textAlign: 'center',
      }}
    >
      <span className="truncate block">{activityCode}</span>
    </div>
  );
};

export default ActivityBlock;
